import { motion } from "framer-motion";
import { Link, useParams } from "react-router-dom";
import { GasStationDetailPanel } from "@/components/gas-stations/GasStationDetailPanel";
import { PageSkeleton } from "@/components/ui/PageSkeleton";
import { useGasStation } from "@/lib/queries";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function GasStationDetailPage() {
  const { id } = useParams<{ id: string }>();
  const stationId = Number(id);
  const { data: station, isLoading, error } = useGasStation(stationId);

  if (isLoading) return <PageSkeleton />;

  if (error || !station) {
    return (
      <motion.div
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.3 }}
        className="space-y-4"
      >
        <Link
          to="/gas-stations"
          className="inline-block text-sm font-semibold text-muted transition hover:text-foreground"
        >
          ← Fuel network
        </Link>
        <p className="text-sm text-muted">Station not found.</p>
      </motion.div>
    );
  }

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to="/gas-stations"
        className="mb-5 inline-block text-sm font-semibold text-muted transition hover:text-foreground"
      >
        ← Fuel network
      </Link>
      <GasStationDetailPanel station={station} />
    </motion.div>
  );
}
